// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card.movil{
	margin:0!important;
	padding: 4px!important;
}
.contenedor {
	height: auto  !important; 
	min-height: 100% !important;
	margin: 0 !important;
	padding: 0  !important;
}

.contenedor.bg-1 {
    background: url('login_fondo.39c709cc9dca2fb9.jpg') no-repeat center center fixed !important;
	background-size: cover!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/auth/confirmacion-email/confirmacion-email.component.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,wBAAwB;CACxB,2BAA2B;CAC3B,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;IACI,4FAA6G;CAIhH,gCAAgC;AACjC","sourcesContent":["mat-card.movil{\r\n\tmargin:0!important;\r\n\tpadding: 4px!important;\r\n}\r\n.contenedor {\r\n\theight: auto  !important; \r\n\tmin-height: 100% !important;\r\n\tmargin: 0 !important;\r\n\tpadding: 0  !important;\r\n}\r\n\r\n.contenedor.bg-1 {\r\n    background: url(\"../../../assets/login/images/auth/login_fondo.jpg\") no-repeat center center fixed !important;\r\n\t-webkit-background-size: cover!important;\r\n\t-moz-background-size: cover!important;\r\n\t-o-background-size: cover!important;\r\n\tbackground-size: cover!important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
